import { IconPropTypes } from '@/legacy/types';

const Gift = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 16}
			height={props.height || 16}
			viewBox='0 0 16 16'
			fill='none'
			{...props}
		>
			<path
				stroke={props.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.14}
				d='M13.923 3.692H2.077C1.482 3.692 1 4.174 1 4.77v2.154C1 7.518 1.482 8 2.077 8h11.846C14.518 8 15 7.518 15 6.923V4.77c0-.595-.482-1.077-1.077-1.077ZM13.923 8v5.923A1.077 1.077 0 0 1 12.846 15H3.154a1.077 1.077 0 0 1-1.077-1.077V8M8 3.692V15M11.23 1 8 3.692 4.77 1'
			/>
		</svg>
	);
};

export default Gift;
